import styled from 'styled-components';

import { Box } from 'components/Box';
import { PrimaryButtonRouterLink } from 'components/Button';
import { LegacyTertiaryButton } from 'components/Button/LegacyTertiaryButton';
import { Divider } from 'components/Divider';
import { Meter } from 'components/Meter';
import ResumeDatabaseResponseContainer from 'containers/ResumeDatabaseResponseContainer';
import { useUserEnvironment } from 'modules/main/store/hooks/useUserEnvironment';
import { colors, fontWeights } from 'theme';
import { trackClicked } from 'utils/analytics/track/trackClicked';

const StyledLinkButton = styled(LegacyTertiaryButton)`
  color: ${colors.battleshipGrey};
  font-size: inherit;
  font-weight: ${fontWeights.normal};
  text-decoration: underline;
`;

type Props = {
  closeMenu: () => void;
};

export function PageHeaderAccountDropdownProfileSection({ closeMenu }: Props) {
  const { user } = useUserEnvironment();
  return (
    <>
      <Divider light my={0} />
      <Box minWidth={200} px={12} pt={16} pb={24} textAlign="center">
        <Box mb="8px" color={colors.battleshipGrey}>
          {getText('Your profile is incomplete')}
        </Box>
        <Meter
          current={1}
          total={3}
          color="turtleGreen"
          delay={0}
          duration={0.5}
        />
        <Box mt={20} mb="8px">
          <PrimaryButtonRouterLink
            to="/dashboard/employment-profile/get-discovered"
            size="small"
            onClick={() => {
              closeMenu();
              trackClicked('Add Resume', {
                context: 'Header User Dropdown',
              });
            }}
          >
            {user?.resumeId ? getText('Share Resume') : getText('Add Resume')}
          </PrimaryButtonRouterLink>
        </Box>
        <Box
          width={1}
          display="flex"
          flexDirection="column"
          alignItems="center"
        >
          {/* @ts-expect-error ts-migrate(2786) FIXME: 'ResumeDatabaseResponseContainer' cannot be used a... Remove this comment to see the full error message */}
          <ResumeDatabaseResponseContainer>
            {({ dismiss }) => (
              <StyledLinkButton
                onClick={() => {
                  dismiss();
                  closeMenu();
                  trackClicked('Dismiss Resume Database CTA', {
                    context: 'Header User Dropdown',
                  });
                }}
              >
                {getText('No, thanks')}
              </StyledLinkButton>
            )}
          </ResumeDatabaseResponseContainer>
        </Box>
      </Box>
    </>
  );
}
